import { Injectable } from '@angular/core';
import { HttpParamsService } from '@api-module/service/http-params.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ApiConstant } from '@api-module/api.endpoint.constant';

@Injectable({
  providedIn: 'root'
})

export class FeesRestService {
	readonly BASE_URL: string = ApiConstant.FEE;
	
	constructor(private http: HttpClient, private paramService: HttpParamsService) {}

	getHKStockFees(type){
		const params = this.paramService.buildHttpParams({type});
		
	    return this.http.post(this.BASE_URL + ApiConstant.FEE_HK_STOCK, {}, {params});
	}

	getUsStockFees(type){
		const params = this.paramService.buildHttpParams({type});
		
	    return this.http.post(this.BASE_URL + ApiConstant.FEE_US_STOCK, {}, {params});
	}

	getStockFeeDetailsByExchange(exchange, productType){
		const params = this.paramService.buildHttpParams({exchange, productType});
		
	    return this.http.post(this.BASE_URL + ApiConstant.FEE_BY_EXCHANGE, {}, {params});
	}
	
	getAllCurrenciesDefaultStockFeeDetails(exchange, productType){
		var params = this.paramService.buildHttpParams({exchange, productType});
		params=params.append('platform', 'FHK');
		params=params.append('channel', 'online');
		
	    return this.http.post(this.BASE_URL + ApiConstant.FEE_ALL_CUR_BY_EXCHANGE, {}, {params});
	}
	
	getBondFeesDetail(accountNo, issueCode, bondCurrencyCode){
		const params = this.paramService.buildHttpParams({accountNo, issueCode, bondCurrencyCode});
						
	    return this.http.post(this.BASE_URL + ApiConstant.GET_BOND_FEES_DETAILS, {}, {params});
	}

	getFundFees(type){
		const params = this.paramService.buildHttpParams({type});

		return this.http.post(this.BASE_URL + ApiConstant.GET_FUND_FEES, {}, {params});
	}
	
	getAllInvoice(paramRefno: string){
		const params = this.paramService.buildHttpParams({paramRefno});
		return this.http.post(ApiConstant.PROTECTED+this.BASE_URL+ApiConstant.GET_ALL_INVOICE,{},{params});
	}
	
	getAsManagementFee(currency:string) {
		const params = this.paramService.buildHttpParams({currency});
		return this.http.post(this.BASE_URL+ApiConstant.GET_AS_MANAGEMENT_FEE,{},{params});
	}
	
}